// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m97wp","left":"styles_left__2wseo","desktopActions":"styles_desktopActions__36DhK","title":"styles_title__30c74"};